<template>
  <HeaderPages />
  <section class="section_header_full_pages">
    <div class="waves_full_pages"></div>
    <div class="container_text_full_pages">
      <h1 class="title_home">
        <span class="title_home_4">НАШИ<br /></span>
        <span class="title_home_1 color_violet"> ПРОЕКТЫ<br /></span>
      </h1>
      <div class="box_button_brifing_full_pages">
        <div class="box_button_v2">
          <button data-action="toggleBig" class="button_v1">
            Оставить заявку
          </button>
        </div>
      </div>
    </div>
  </section>
  <SectionProjectsMain />
  <FooterPages />
</template>
<script>
import HeaderPages from "../permanent/HeaderPages.vue";
import FooterPages from "../permanent/FooterPages.vue";
import SectionProjectsMain from "../ui/SectionProjectsMain.vue";
import { useHead } from "@vueuse/head";
export default {
  components: { HeaderPages, SectionProjectsMain, FooterPages },
  setup() {
    useHead({
      title:
        "Наши проекты: кейсы по разработке сайтов, дизайну и цифровым решениям",
      meta: [
        {
          name: "description",
          content:
            "Посмотрите наши реализованные проекты: корпоративные сайты, интернет-магазины, UX/UI дизайн и мобильные приложения. Решения, которые помогают бизнесу расти и развиваться.",
        },
      ],
    });
  },
  data() {
    return {
      activeButtons: [],
      activeButtonsV2: [],
      activeButtonsV3: [],
      buttons: [
        { text: "Все статьи" },
        { text: "Разработка" },
        { text: "Дизайн" },
        { text: "Дизайн" },
      ],
      buttonsV2: [
        { text: "Все статьи" },
        { text: "Разработка" },
        { text: "Дизайн" },
        { text: "Дизайн" },
      ],
      buttonsV3: [
        { text: "Все статьи" },
        { text: "Разработка" },
        { text: "Дизайн" },
        { text: "Дизайн" },
      ],
      openImageSrc: require("@/assets/elements/img_bitton_open.svg"),
      closeImageSrc: require("@/assets/elements/img_bitton_close.svg"),
      isFilterOpen: null,
    };
  },
  methods: {
    handleClick(index) {
      if (this.activeButtons.includes(index)) {
        // Если кнопка уже активна, удаляем ее из массива
        this.activeButtons = this.activeButtons.filter((i) => i !== index);
      } else {
        // Иначе добавляем индекс в массив активных кнопок
        this.activeButtons.push(index);
      }
      console.log("Индекс:", index);
      console.log("Текст:", this.buttons[index].text);
    },
    handleClickV2(index) {
      if (this.activeButtonsV2.includes(index)) {
        // Если кнопка уже активна, удаляем ее из массива
        this.activeButtonsV2 = this.activeButtonsV2.filter((i) => i !== index);
      } else {
        // Иначе добавляем индекс в массив активных кнопок
        this.activeButtonsV2.push(index);
      }
      console.log("Индекс:", index);
      console.log("Текст:", this.buttonsV2[index].text);
    },
    handleClickV3(index) {
      if (this.activeButtons.includes(index)) {
        // Если кнопка уже активна, удаляем ее из массива
        this.activeButtonsV3 = this.activeButtonsV3.filter((i) => i !== index);
      } else {
        // Иначе добавляем индекс в массив активных кнопок
        this.activeButtonsV3.push(index);
      }
      console.log("Индекс:", index);
      console.log("Текст:", this.buttonsV3[index].text);
    },

    toggleFilter(filterId) {
      if (this.isFilterOpen === filterId) {
        this.isFilterOpen = null; // Закрываем фильтр, если он уже открыт
      } else {
        this.isFilterOpen = filterId; // Открываем выбранный фильтр
      }
    },
  },
};
</script>
